import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import {
  addBackOfficeCondominioMassimaleAmount, addBackOfficeQuoteToCart, loadBackOfficeQuotes, removeBackOfficeQuoteFromCart, resetBackOfficeQuotes,
} from '../../../features/backofficeResults/backofficeResultsActions';
import { getQuoteTypes } from '../../../features/utilities/utilitiesActions';
import PageLoading from '../../../common/componentsV2/elements/PageLoading';
import { confirmAlert } from '../../../common/utils/alerts';
import { EstimateContainer } from '../../../common/components/redesignComponents/common/Redesign.styles';
import { RiskContainer } from '../../CondominioProduct/styles/CondominioResultPage.styles';
import CondominioModalButtons from '../../CondominioProduct/components/CondominioModalButtons';
import CondominioModal from '../../CondominioProduct/components/CondominioModal';
import { FormInputText } from '../../../common/formInputsV2/FormInputText';
import { riskCardStyles } from '../../../common/components/redesignComponents/ResultPageComponents/RcQuotesModal.style';
import { RiskCard, RiskButton } from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultSlotCard.styles';
import { safeCapitalizeWords } from '../../../common/constants';
import { V2FontImport } from '../../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import CondominioSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/CondominioSummaryCard';
import QuoteCostSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';

const isMassimaleValueType = (typeId) => ['cristalli_e_vetri', 'assistenza'].includes(typeId);

function MassimaleValueInputCard({
  type,
  requestInfo,
  massimaleAmount,
  setMassimaleAmount,
  saveMassimaleAmount,
  riskQuotations,
}) {
  return (
    <RiskCard className={riskCardStyles(requestInfo, type, riskQuotations)}>
      <div className="me-auto">
        <h5>{safeCapitalizeWords(type.name)}</h5>
      </div>
      <div className="my-auto">
        <FormInputText
          label="Inserisci massimale"
          type="number"
          value={massimaleAmount[type.id]}
          onWheel={(e) => e.target.blur()}
          onChange={(value) => setMassimaleAmount({ ...massimaleAmount, [type.id]: value })}
        />
      </div>
      {massimaleAmount[type.id].length >= 3 && (
        <RiskButton onClick={() => saveMassimaleAmount(type)}>
          Salva
        </RiskButton>
      )}
    </RiskCard>
  );
}

function BackOfficeCondominioQuotes() {
  const { requestToken } = useParams();
  const [massimaleAmount, setMassimaleAmount] = useState({
    cristalli_e_vetri: '',
    assistenza: '',
  });
  const state = useSelector((store) => store.backofficeResults.back_office_quotes);
  const {
    loading,
    requestInfo,
    quotes,
    processingQuote,
    addingQuote,
    customer,
    risk_quotations,
  } = state;

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  useEffect(() => {
    loadBackOfficeQuotes(requestToken);
    getQuoteTypes();

    return () => {
      resetBackOfficeQuotes();
    };
  }, []);

  if (loading) {
    return <PageLoading />;
  }

  const fetchQuotes = () => {
    loadBackOfficeQuotes(requestToken);
  };

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addBackOfficeQuoteToCart(quoteId, fetchQuotes));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeBackOfficeQuoteFromCart(quoteId, fetchQuotes));
  };

  const saveMassimaleAmount = (type) => {
    addBackOfficeCondominioMassimaleAmount(
      requestToken,
      fetchQuotes,
      massimaleAmount[type.id],
      setMassimaleAmount,
      type.id,
    );
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (risk_quotations && risk_quotations[type.id] !== undefined) {
        for (let i = 0; i < risk_quotations[type.id].length; i++) {
          const item = risk_quotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };
  return (
    <Layout>
      <V2FontImport />
      <div className="resultsPage mx-auto w-75">
        <ResultOverviewRow>
          <CondominioSummaryCard
            customer={customer}
            insuranceRequest={requestInfo}
          />
          <QuoteCostSummaryCard
            processingQuote={processingQuote}
            quoteTypes={quoteTypes}
            riskQuotations={risk_quotations}
            getTotal={getTotal}
            rcTypeLabel={processingQuote?.product_name}
          />
        </ResultOverviewRow>
        <div className="row">
          <div className="col-12 ">
            <EstimateContainer>
              <div className="d-flex gap-2 justify-content-end ">
                <div>
                  {/* {localStorage.getItem('quoteNewResult') === 'done' && (
                      <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                        <button className="btn btn-success px-2 py-1">Tutorial</button>
                      </div>
                    )} */}
                </div>
              </div>
            </EstimateContainer>
          </div>
        </div>
        {quotes && !quotes.res_civile
          && (
            <div className="alert alert-info mx-2" role="alert">
              <h4 className="alert-heading">Avviso!</h4>
              <p className="m-0">Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
            </div>
          )}

        {quotes && quotes.res_civile
          && (
            <>
              <RiskContainer className="mb-3 pb-3 result-home-third-step">
                {quoteTypes.map((type, index) => {
                  const showMassimaleValueInput = isMassimaleValueType(type.id)
                    && requestInfo.product_id == 1003 && quotes?.[type.id] === undefined;

                  return (
                    <React.Fragment key={index}>
                      {quotes && quotes[type.id] && (
                        <CondominioModalButtons
                          insuranceRequest={requestInfo}
                          processingQuote={processingQuote}
                          type={type}
                          removeItemFromCart={removeItemFromCart}
                          riskQuotations={risk_quotations}
                        />
                      )}

                      {showMassimaleValueInput && (
                        <MassimaleValueInputCard
                          type={type}
                          requestInfo={requestInfo}
                          massimaleAmount={massimaleAmount}
                          setMassimaleAmount={setMassimaleAmount}
                          saveMassimaleAmount={saveMassimaleAmount}
                          riskQuotations={risk_quotations}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
              </RiskContainer>
              {quoteTypes.map((type, index) => (
                <CondominioModal
                  insuranceRequest={requestInfo}
                  type={type}
                  key={index}
                  addingQuote={addingQuote}
                  quotations={quotes}
                  selectQuotation={selectQuotation}
                  processingQuote={processingQuote}
                />
              ))}
            </>
          )}
      </div>
    </Layout>
  );
}

export default BackOfficeCondominioQuotes;
